import CreateLayout from "@/shared/components/Layouts/CreateLayout";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import CkEditorInput from "./CkEditorInput";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useMutation } from "@apollo/client";
import { CREATE_JOB_POST, UPDATE_JOB_POST } from "@/GraphQL/Mutation";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import { id } from "date-fns/locale";

const NewJobPost = () => {
  const [createJobPost] = useMutation(CREATE_JOB_POST);
  const [updateJobPost] = useMutation(UPDATE_JOB_POST);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const updateData = history?.location?.state?.updateData || {};
  console.log("🚀 ~ NewJobPost ~ updateData:", updateData);

  const { control, watch } = useForm();

  const workPlaceOptions = [
    { value: "On Site", label: "On Site" },
    { value: "Remote", label: "Remote" },
    { value: "Hybrid", label: "Hybrid" },
  ];

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "InActive" },
  ];

  const forms = [
    {
      name: "job_title",
      placeholder: "Enter Job Title",
      rules: () => ({ required: "This is required field" }),
      label: "Job Title",
      type: "text",
      deviceSize: 12,
      defaultValue: updateData?.job_title || "",
    },
    {
      name: "salary",
      placeholder: "Enter Salary Range",
      rules: () => ({
        required: "This is required field",
        maxLength: {
          value: 100,
          message: "Maximum 100 characters allowed",
        },
      }),
      label: "Salary Range",
      type: "text",
      deviceSize: 6,
      defaultValue: updateData?.salary || "",
    },
    {
      name: "work_place",
      placeholder: "Select Work Place",
      rules: () => ({ required: "This is required field" }),
      label: "Work Place",
      type: "select",
      deviceSize: 6,
      options: workPlaceOptions,
      defaultValue:
        workPlaceOptions.find(
          (item) => item?.value === updateData?.work_place
        ) || "",
    },
    {
      name: "dead_line",
      placeholder: "Enter Deadline",
      rules: () => ({ required: "This is required field" }),
      label: "Dead Line",
      type: "date",
      deviceSize: 6,
      minDate: new Date(),
      defaultValue: updateData?.dead_line
        ? new Date(Number(updateData?.dead_line))
        : null,
    },
    {
      name: "is_active",
      placeholder: "Select Status",
      rules: () => ({ required: "This is required field" }),
      label: "Status",
      type: "select",
      deviceSize: 6,
      options: statusOptions,
      defaultValue:
        typeof updateData?.is_active === "number"
          ? statusOptions.find((item) => item?.value === updateData?.is_active)
          : "",
    },
    // {
    //   name: "description",
    //   label: "Description",
    //   type: "custom",
    //   rules: () => ({
    //     required: "Description is required"
    //   }),
    //   height: 700,
    //   width: "100%",
    //   customComponent: CkEditorInput,
    //   defaultValue: updateData?.description || "",
    //   placeholder: "Write description here...",
    // },
    {
      name: "description",
      label: "Description",
      type: "custom",
      rules: () => ({
        required: "Description is required",
        validate: {
          maxChars: (v) => {
            const plain = (v || "")
              .replace(/<[^>]*>/g, "")
              .replace(/&nbsp;/g, " ")
              .trim();
            return (
              plain.length <= 5000 ||
              `Maximum 5000 characters (currently ${plain.length}).`
            );
          },
        },
      }),
      height: 700,
      width: "100%",
      customComponent: CkEditorInput,
      defaultValue: updateData?.description || "",
      placeholder: "Write description here...",
      // pass max to the component for live counter
      customProps: { maxChars: 5000 },
    },
  ];

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const jobPostData = {
        job_title: data?.job_title,
        salary: data?.salary,
        description: data?.description,
        work_place: data?.work_place?.value,
        dead_line: data?.dead_line,
        is_active: data?.is_active?.value,
      };
      const updateJobPostData = {
        id: updateData?.id,
        job_title: data?.job_title,
        salary: data?.salary,
        description: data?.description,
        work_place: data?.work_place?.value,
        dead_line: data?.dead_line,
        is_active: data?.is_active?.value,
      };

      if (updateData?.id) {
        const result = await updateJobPost({ variables: updateJobPostData });
        if (result?.data?.updateJobPost?.result_code === "000") {
          Swal.fire("Updated!", "Job Post has been Updated.", "success");
          setIsLoading(false);
          history.push("/job_post/list");
        } else {
          Swal.fire(
            "Failed",
            result?.data?.updateJobPost?.status || "Something went wrong",
            "error"
          );
        }
        setIsLoading(false);
      } else {
        const result = await createJobPost({
          variables: jobPostData,
        });

        if (result?.data?.createJobPost?.result_code === "000") {
          Swal.fire("Created!", "Job Post has been created.", "success");
          history.push("/job_post/list");
        } else {
          Swal.fire(
            "Failed",
            result?.data?.createJobPost?.status || "Something went wrong",
            "error"
          );
        }
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Job post creation failed:", err);
      Swal.fire("Error", err.message, "error");
      setIsLoading(false);
    }
  };
  //  onClick={() => history.push("/leave/holydays")}
  return (
    <Card>
      <CardBody>
        <h3 className="mb-5">
          {updateData?.id ? "Update Job Post" : "Create Job Post"}
        </h3>
        <Row>
          <Col md={10} className="mx-auto">
            <CreateLayout
              onSubmit={handleSubmit}
              forms={forms}
              control={control}
              watch={watch}
              loading={isLoading}
              submitText={updateData?.id ? "Update" : "Publish"}
              cancelPath={"/job_post/list"}
              onCancel={() => history.push("/job_post/list")}
              title={updateData?.id ? "Update Job Post" : "Create Job Post"}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default NewJobPost;
